module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-300italic.14286f3.woff2";